var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt4 overflow-hidden h-auto"},[_c('p',[_vm._v("Which hymnal are you using?")]),_c('div',{staticClass:"list mh0 ph0 flex flex-column items-stretch"},_vm._l((_vm.hymnals),function(hymnal){return _c('router-link',{key:hymnal.id,staticClass:"f4 glow hover-bg-blue hover-white link ba ph3 pv2 mb2 dib blue pointer br2 self-stretch",attrs:{"to":{
        name: 'hymnal',
        params: {
          hymnalUrl: hymnal.url
        }
      }}},[_vm._v(_vm._s(hymnal.name)+"\n      ")])}),1),_c('div',[_vm._v("Updated: November 2024")])])}
var staticRenderFns = []

export { render, staticRenderFns }